"use client";

import { useState } from "react";

export type BillingPeriod = "monthly" | "annual";

interface PricingToggleProps {
  defaultPeriod?: BillingPeriod;
  onChange: (period: BillingPeriod) => void;
}

export function PricingToggle({
  defaultPeriod = "annual",
  onChange,
}: PricingToggleProps) {
  const [period, setPeriod] = useState<BillingPeriod>(defaultPeriod);

  function handleToggle(newPeriod: BillingPeriod) {
    setPeriod(newPeriod);
    onChange(newPeriod);
  }

  return (
    <div
      className="grid w-full grid-cols-2 items-stretch rounded-full border border-border bg-surface-muted p-1"
      data-testid="pricing-toggle"
    >
      <button
        onClick={() => handleToggle("monthly")}
        className={`rounded-full px-3 py-2 text-sm font-semibold transition-colors ${
          period === "monthly"
            ? "bg-navy text-white"
            : "text-muted hover:text-foreground"
        }`}
      >
        Monthly {"\u00a339"}
      </button>
      <button
        onClick={() => handleToggle("annual")}
        className={`relative rounded-full px-3 py-2 text-sm font-semibold transition-colors ${
          period === "annual"
            ? "bg-navy text-white"
            : "text-muted hover:text-foreground"
        }`}
      >
        Annual {"\u00a3360"}
        <span
          className="ml-1.5 inline-flex items-center rounded-full bg-done-bg px-2 py-0.5 text-[11px] font-bold text-done motion-safe:animate-pulse-once max-[420px]:mt-1 max-[420px]:block"
          data-testid="save-badge"
        >
          {"\u00a330/month"} equiv.
        </span>
      </button>
    </div>
  );
}
